import {
  useGetResourceAgendaPublicBoard,
  usePublicViews
} from "@swivu/client-api";
import { useParams } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu.js";
import { AnimatePresence, motion } from "motion/react";

const Header = () => {
  // const { data } = useQuickLinksInfo();
  const { slug, id } = useParams();
  const { data, isLoading } = useGetResourceAgendaPublicBoard({
    variables: {
      slug: slug ?? ""
    },
    enabled: !!slug
  });
  const { data: views } = usePublicViews({
    variables: {
      slug: slug as string
    },
    networkMode: "offlineFirst"
  });

  const selectedBoard = views?.find((view) => view.id === Number(id));

  return (
    <>
      <header className="bg-background border-border dark:text-mono-300 flex flex-none gap-4  border-b px-4 py-2 md:h-16 md:px-0 md:py-0 ">
        <HamburgerMenu />
        <div className="mx-auto flex w-full  max-w-5xl items-center justify-between  ">
          <div
            // to={{ pathname: `/`, search: location.search }}
            className="flex flex-1  flex-col gap-x-4"
          >
            {/* <img
              className="h-8 w-auto -ml-1"
              src="/assets/swivu-logo.svg"
              alt="Swivu"
            /> */}
            <h1 className={`text-xl font-bold`}>
              {data?.board_name ?? (isLoading ? "" : "Swivu")}
            </h1>
            <AnimatePresence>
              {selectedBoard && (
                <motion.p
                  // key={selectedBoard.id}
                  className="ml-0.5 flex items-center gap-2"
                  transition={{
                    duration: 0.5,
                    bounce: 0,
                    type: "spring"
                  }}
                  initial={{ opacity: 0, height: 0 }}
                  animate={{
                    opacity: 1,
                    height: "auto",
                    transition: { delay: 0.3 }
                  }}
                  exit={{ opacity: 0, height: 0 }}
                >
                  {/* {selectedBoard?.icon && (
                  <i
                    key={selectedBoard?.icon ?? "fa-list"}
                    className={`fa-regular size-3 ${decodeFA(
                      selectedBoard?.icon ?? "fa-list"
                    )}`}
                  />
                   )}   */}
                  <span className="text-xs font-bold">
                    {selectedBoard?.name}
                  </span>
                </motion.p>
              )}
            </AnimatePresence>
          </div>
        </div>
        {/* <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
      <div className="fixed inset-0 z-50" />
      <Dialog.Panel className="fixed inset-y-0 left-0 z-50 w-full overflow-y-auto bg-white px-4 pb-6 sm:max-w-sm sm:px-6 sm:ring-1 sm:ring-mono-900/10">
        <div className="-ml-0.5 flex h-16 items-center gap-x-6">
          <button type="button" className="-m-2.5 p-2.5 text-mono-700" onClick={() => setMobileMenuOpen(false)}>
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="-ml-0.5">
            <a href="#" className="-m-1.5 block p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                className="h-8 w-auto"
                src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                alt=""
              />
            </a>
          </div>
        </div>
        <div className="mt-2 space-y-2">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-mono-900 hover:bg-mono-50"
            >
              {item.name}
            </a>
          ))}
        </div>
      </Dialog.Panel>
    </Dialog> */}
      </header>
    </>
  );
};
export default Header;
